import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'tallymark-1', 'Tallymark1', [["path",{"d":"M12 5l0 14"}]]);